/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSendSafelyRecipientInfo} from '../api'

 export const useQueryGetSendSafelyRecipientInfo = createReactQueryHook('getSendSafelyRecipientInfo', getSendSafelyRecipientInfo)
